"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputGroupItem = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var utils_1 = require("../utils");
var hooks_1 = require("../utils/hooks");
var ConfigProvider_1 = require("../ConfigProvider");
var input_1 = require("./input");
function InputGroup(_a) {
    var size = _a.size, validateStatus = _a.validateStatus, className = _a.className, children = _a.children, otherProps = tslib_1.__rest(_a, ["size", "validateStatus", "className", "children"]);
    var _b = hooks_1.useFocused(), focused = _b.focused, focusedHandlers = _b.focusedHandlers;
    var inputGroupClassName = ConfigProvider_1.usePrefix('input-group');
    var inputStyleClassName = input_1.useInputStyle({
        focused: focused,
        validateStatus: validateStatus,
        size: size,
        disabled: false
    });
    var wrapperClassName = classnames_1.default(inputGroupClassName, inputStyleClassName, className);
    return (react_1.default.createElement("div", tslib_1.__assign({}, otherProps, focusedHandlers, { className: wrapperClassName }), children));
}
exports.default = InputGroup;
function InputGroupItem(_a) {
    var _b = _a.grey, grey = _b === void 0 ? true : _b, className = _a.className, style = _a.style, children = _a.children;
    var inputGroupItemClassName = ConfigProvider_1.usePrefix('input-group-item');
    var inputStyleClassName = input_1.useInputStyle({ focused: false, disabled: false });
    var wrapperClassName = classnames_1.default(inputGroupItemClassName, grey && utils_1.concat(inputGroupItemClassName, 'grey'), inputStyleClassName, className);
    return (react_1.default.createElement("div", { className: wrapperClassName, style: style }, children));
}
exports.InputGroupItem = InputGroupItem;
//# sourceMappingURL=InputGroup.js.map